import { createSlice } from '@reduxjs/toolkit'
import { DashboardState } from './types'
import { format, subDays } from 'date-fns'
import { STOP_SALES_DATE_FORMAT } from 'constants/date'

const DAYS_COUNT = 29

const initialState: DashboardState = {
  selectedDashboardRange: {
    from: format(subDays(new Date(), DAYS_COUNT), STOP_SALES_DATE_FORMAT),
    to: format(new Date(), STOP_SALES_DATE_FORMAT),
  },
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setSelectedDashboardRange(state, action) {
      state.selectedDashboardRange = action.payload
    },
    resetDashboardData() {
      return initialState
    },
  },
})

export const dashboardReducer = dashboardSlice.reducer
export const { setSelectedDashboardRange, resetDashboardData } =
  dashboardSlice.actions
